import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "flex items-center gap-2 transition",
    passwordStrengthText: "text-nowrap transition",
  },

  variants: {
    color: {
      default: {},
      primary: {},
      secondary: {},
      danger: {
        passwordStrengthText: "!text-danger-600",
      },
      warningO: {
        passwordStrengthText: "!text-warningO-600 dark:!text-warningO-600",
      },

      success: {
        passwordStrengthText: "!text-success-600",
      },
    },

    isHidden: {
      true: {
        base: "hidden",
      },
      false: {},
    },
  },
});
